_ = require('lodash')

GroupInfoMembersCtrl = ($scope ,$location ,GroupMemberService, $translate, $filter) ->
  $scope.displayUserName = (fName , lName) ->
    fName = fName ? ''
    lName = lName ? ''
    if fName + lName == ''
      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')

    if /^ja/i.test $translate.preferredLanguage()
      return lName + " " + fName
    return fName + " " + lName
  pageSize = 15
  currentPage = 1
  infoMembersCtrl = this
  infoMembersCtrl.isLoading = false
  infoMembersCtrl.lsMembers = []
  infoMembersCtrl.lsAdmins = []

  infoMembersCtrl.goToListMember = ->
    $location.path("/groups/#{$scope.groupInfo.id}/members/list-members")

  infoMembersCtrl.goToAllMembers = ->
    $location.path("/groups/#{$scope.groupInfo.id}/members")

  $scope.getTextOfAvatar = (user) ->
    $avatarElement = $(".avatar-for-#{user.id} .avatar-image-text:not(.is-small)")
    if user.display_text_avatar.length == 1
      $avatarElement.removeClass('two-characters')
      $avatarElement.addClass('one-character')
    else
      $avatarElement.removeClass('one-character')
      $avatarElement.addClass('two-characters')
    user.display_text_avatar

  $scope.isAvatarColor = (user) ->
    user.avatar_image_path?.indexOf('avatar_color') > -1

  loadMembers = (type) ->
    params =
      id: $scope.groupInfo.id
      page_size : pageSize
      page: currentPage
      role: type ? ""
    infoMembersCtrl.isLoading = true
    GroupMemberService.listMembers(params)
    .then (data) ->
      if type == 'admin'
        infoMembersCtrl.lsAdmins = _.union(infoMembersCtrl.lsAdmins , data.members )
      else
        infoMembersCtrl.lsMembers = _.union(infoMembersCtrl.lsMembers , data.members )
    .finally ->
      infoMembersCtrl.isLoading = false

  loadMembers('member')
  loadMembers('admin')
  infoMembersCtrl

GroupInfoMembersCtrl.$inject = [
  '$scope'
  '$location'
  'GroupMemberService'
  '$translate'
  '$filter'
]

module.exports = GroupInfoMembersCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/group-info-members-controller.coffee